import { atsSubscriberSessionStorageKey } from '@hooks/useSessionStorage';
import { SubscriberWithToken } from '@modules/simulations/types';

export const getAtsTokenFromSessionStorage = (): string | undefined => {
  const str = sessionStorage.getItem(atsSubscriberSessionStorageKey);
  if (!str) return;
  const obj: SubscriberWithToken = JSON.parse(str);
  return obj.atsToken;
};

export const removeAtsSubscriberFromSessionStorage = () =>
  sessionStorage.removeItem(atsSubscriberSessionStorageKey);
